import React, { Component } from 'react';
import styles from './index.less';

export default class ColorModule extends Component {
  render() {
    const { modules = [] } = this.props;
    const colorType = {
      1: '#FA943E',
      2: '#7657E7',
      3: '#F25C42',
      4: '#2EB883',
      5: '#5C78E7',
      6: '#F9BA42',
    };
    return (
      <div className={styles.colorModule}>
        {modules.map((item, index) => {
          let file = [];
          let color = '';
          if (item.fileId.indexOf(';') !== -1) {
            file = item.fileId && item.fileId.split(';');
            [, color] = file;
          } else if (item.fileId.indexOf('#') !== -1) {
            color = item.fileId;
          }
          return (
            <div key={item.id} style={{ backgroundColor: color || colorType[index + 1] }}>
              {item.moduleName}
            </div>
          );
        })}
      </div>
    );
  }
}
